export default {
    CREATE_SUMMARY_REPORT: "Создание отчета",
    EDIT_SUMMARY_REPORT: "Редактирование отчета"
};
